/**
 * Decorative celebration washes used behind confetti-backed "complete"/milestone states.
 * Shared so both the block layer (`AccountBlock`) and the presentational
 * components/stories reference one source instead of re-declaring the string.
 *
 * - WARM_LIME_ACCENT_GRADIENT: 20%-opacity warm→lime wash; layer over `background.paper`
 *   for a tinted background. Used for merchant categorization and deposit celebration states.
 * - CELEBRATION_GRADIENT: 20%-opacity warm→pink wash; layer over `background.paper`.
 * - DISCOVERED_ACCOUNTS_GRADIENT: Fully opaque (100% opacity); use as the sole background.
 */

/**
 * Warm → lime accent wash at 20% opacity. Used as a tinted background behind
 * merchant categorization highlights and deposit celebration callouts.
 */
export const WARM_LIME_ACCENT_GRADIENT =
  'linear-gradient(200.73deg, rgba(255, 223, 152, 0.2) 1.86%, rgba(173, 248, 43, 0.2) 101.54%)'

/** Warm → pink wash behind balance/savings milestones. */
export const CELEBRATION_GRADIENT =
  'linear-gradient(200.73deg, rgba(255, 223, 152, 0.2) 1.86%, rgba(255, 128, 229, 0.2) 101.54%)'

/** Peach → pink gradient for Discovered Accounts success state. */
export const DISCOVERED_ACCOUNTS_GRADIENT =
  'linear-gradient(200.73deg, rgba(255, 224, 153, 1) 1.86%, rgba(255, 129, 230, 1) 101.54%)'

/**
 * Warm → pink wash at 20% opacity for the account-connected success state.
 * Layer over `background.paper` (the Figma spec's `#FFF` base), not the
 * `background` shorthand — a 20% gradient over transparency renders wrong.
 */
export const ACCOUNT_CONNECTED_GRADIENT =
  'linear-gradient(257deg, rgba(255, 224, 153, 0.2) 1.86%, rgba(255, 129, 230, 0.2) 101.54%)'
